import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';


const useRedirect = () => {
  const navigate = useNavigate();
  const restaurantDetailFailure = useSelector(
    (state: any) => state.restaurant.restaurantDetailsFailure
  );

  useEffect(() => {
    if (restaurantDetailFailure) {
      navigate("/notFound")
    }
  }, [restaurantDetailFailure])

  return {

  };
};

export default useRedirect;
